module.exports = __webpack_public_path__ + "static/media/img3.40ded502.jpg";